import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import makeRootReducer from './reducers'
import { idleTimeUpdater } from '../containers/Auth'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import promiseMiddleware from 'redux-promise-middleware'
import actionLogger from 'state/middleware/actionLogger'
import { enableActionLogger } from 'configs'

export default (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [ idleTimeUpdater, thunk, promiseMiddleware() ]
  if (enableActionLogger()) {
    middleware.push(actionLogger())
  }
  // ======================================================
  // Store Enhancers
  // ======================================================
  const composeEnhancers = composeWithDevTools({
    trace: false,
    traceLimit: 25,
  })

  // const addPromiseSupportToDispatch = store => {
  //   const rawDispatch = store.dispatch
  //   return action => {
  //     if (typeof action.then === 'function') {
  //       return action.then(rawDispatch)
  //     }
  //     return rawDispatch(action)
  //   }
  // }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  )
  store.asyncReducers = {}
  // store.dispatch = addPromiseSupportToDispatch(store)

  store.injectReducer = (name, reducer) => {
    if (!Object.keys(store.asyncReducers).includes(name)) {
      store.asyncReducers[name] = reducer
      // console.log(store.asyncReducers)
      store.replaceReducer(makeRootReducer(store.asyncReducers, initialState))
      store.dispatch({ type: 'ADD_NEW_REDUCER', payload: name })
    }
  }

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      // eslint-disable-next-line
      const reducers = require('./reducers').default
      store.replaceReducer(reducers)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/legacy/store/createStore.js